import React from "react";
import female from "./female.svg"
function Female() {

    return(
        <React.Fragment>
            <img src={female} alt="Logo" height="150" width="150"/>
        </React.Fragment>
    )

}

export default Female